import { map } from 'rxjs/operators';
import { RestaurantService } from './restaurant.service';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Hashes, Session } from '../restaurant-manager.models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionService {

    constructor(
        protected apiService: ApiService,
        protected restaurantService: RestaurantService
    ) {}

    getLastSessionHashes(): Observable<any> {
        return this.apiService.get<Hashes>('/restaurants/' + this.restaurantService.selectedRestaurant.value.id + '/hashes/last', true).pipe(map((hashes: any) => {
            return hashes;
        }));
    }

    openSession(restaurantId: string): Observable<Session> {
        return this.apiService.post<Session>('/sessions/restaurants/' + restaurantId + '/open', {}, true).pipe(map(s => {
            return new Session(s);
        }));
    }

    closeSession(restaurantId: string, data: any): Observable<Session> {
        return this.apiService.post<Session>('/sessions/restaurants/' + restaurantId + '/close', data, true).pipe(map(s => {
            return new Session(s);
        }));
    }

    getSessionHash(sessionId: string): Observable<string> {
        return this.apiService.get<string>('/sessions/' + sessionId + '/hash-key', true);
    }

    getOpenedSession(restaurantId: string): Observable<Session> {
        return this.apiService.get<Session>('/sessions/restaurants/' + restaurantId + '/opened', true).pipe(map(s => {
            return s?.id ? new Session(s) : null;
        }));
    }

}
